import { c as _c } from "react/compiler-runtime";
import { HotelSearchNoResultPropertiesType } from "@website/accommodation-ui/hotel-search/hotel-search-panel/hotel-search-no-result/hotel-search-no-result.types";
export const useHotelSearchNoResult = properties => {
  const $ = _c(2);
  const {
    query
  } = properties;
  let t0;
  if ($[0] !== query) {
    t0 = {
      resultTitle: "\u0646\u062A\u0627\u06CC\u062C \u062C\u0633\u062A\u062C\u0648",
      notFoundtitle: "\u0646\u062A\u06CC\u062C\u0647 \u0627\u06CC \u06CC\u0627\u0641\u062A \u0646\u0634\u062F.",
      firstDescription: <>نتیجه‌ا‌ی برای ”<span className="text-on-surface-high-emphasis">{query}</span>” پیدا نکردیم.</>,
      secondDescription: "\u0628\u0627 \u06A9\u0644\u0645\u0647 \u06CC \u062F\u06CC\u06AF\u0631\u06CC \u062C\u0633\u062A\u062C\u0648 \u06A9\u0646\u06CC\u062F."
    };
    $[0] = query;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};